var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearchIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4746 5.875C10.4746 3.18261 8.35128 1 5.73203 1C3.11277 1 0.989443 3.18261 0.989443 5.875C0.989443 8.56739 3.11277 10.75 5.73203 10.75C8.35128 10.75 10.4746 8.56739 10.4746 5.875ZM1.81239 5.875C1.81239 3.6498 3.56727 1.84593 5.73203 1.84593C7.89678 1.84593 9.65166 3.6498 9.65166 5.875C9.65166 8.1002 7.89678 9.90407 5.73203 9.90407C3.56727 9.90407 1.81239 8.1002 1.81239 5.875Z",
    fill: "#2D2D2D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.73203 0.75C8.4958 0.75 10.7246 3.05107 10.7246 5.875H10.2246C10.2246 3.31415 8.20677 1.25 5.73203 1.25V0.75ZM0.739443 5.875C0.739443 3.05107 2.96825 0.75 5.73203 0.75V1.25C3.25729 1.25 1.23944 3.31415 1.23944 5.875H0.739443ZM5.73203 11C2.96825 11 0.739443 8.69892 0.739443 5.875H1.23944C1.23944 8.43585 3.25729 10.5 5.73203 10.5V11ZM10.7246 5.875C10.7246 8.69892 8.4958 11 5.73203 11V10.5C8.20677 10.5 10.2246 8.43585 10.2246 5.875H10.7246ZM5.73203 2.09593C3.71179 2.09593 2.06239 3.78134 2.06239 5.875H1.56239C1.56239 3.51827 3.42276 1.59593 5.73203 1.59593V2.09593ZM9.40166 5.875C9.40166 3.78134 7.75226 2.09593 5.73203 2.09593V1.59593C8.0413 1.59593 9.90166 3.51827 9.90166 5.875H9.40166ZM5.73203 9.65407C7.75226 9.65407 9.40166 7.96866 9.40166 5.875H9.90166C9.90166 8.23173 8.0413 10.1541 5.73203 10.1541V9.65407ZM2.06239 5.875C2.06239 7.96866 3.71179 9.65407 5.73203 9.65407V10.1541C3.42276 10.1541 1.56239 8.23173 1.56239 5.875H2.06239Z",
    fill: "#2D2D2D"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0661 13.5937L8.50913 9.53125",
    stroke: "#2D2D2D",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchIcon);
export default __webpack_public_path__ + "static/media/search-icon.14a2466df24ece7ab2a0602c09d75f68.svg";
export { ForwardRef as ReactComponent };